import { RSAA } from 'redux-api-middleware';
import getRegionsURL from 'url-constructors/getRegionsURL';
import { Dispatch } from 'redux';
import { TGetRootState, TAsyncDispatchResult } from 'types/shared';
import { IRegionProps } from 'types/shared';

const REQUEST = 'opus/regions/REQUEST';
const SUCCESS = 'opus/regions/SUCCESS';
const FAILURE = 'opus/regions/FAILURE';

type RegionsActionTypes = typeof REQUEST | typeof SUCCESS | typeof FAILURE;

interface IRegionsState {
  pending: boolean;
  fulfilled: boolean;
  error: boolean;
  reason: any;
  data: IRegionProps[];
}

interface IRegionsAction {
  type: RegionsActionTypes;
  payload: IRegionProps[];
}

const initialState: IRegionsState = {
  pending: false,
  fulfilled: false,
  error: false,
  reason: null,
  data: [],
};

function reducer(
  state: IRegionsState = initialState,
  action: IRegionsAction
): IRegionsState {
  switch (action.type) {
    case REQUEST: {
      return {
        ...state,
        pending: true,
        fulfilled: false,
        error: false,
      };
    }
    case SUCCESS: {
      return {
        ...state,
        pending: false,
        fulfilled: true,
        error: false,
        data: action.payload,
      };
    }
    case FAILURE: {
      return {
        ...state,
        pending: false,
        fulfilled: false,
        error: true,
        reason: action.payload,
      };
    }
    default: {
      return state;
    }
  }
}

function loadRegions(): TAsyncDispatchResult {
  return async function (
    dispatch: Dispatch,
    getState: TGetRootState
  ): Promise<any> {
    const { regions } = getState();
    // bail out if the countries are already loading or fulfilled
    if (regions.pending || regions.fulfilled) {
      return;
    }

    return await dispatch({
      [RSAA]: {
        types: [
          REQUEST,
          {
            type: SUCCESS,
            payload: async function payload(
              action: IRegionsAction,
              state: IRegionsState,
              res: any
            ): Promise<IRegionProps[]> {
              const json = await res.json();
              return json.data;
            },
          },
          FAILURE,
        ],
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        method: 'GET',
        endpoint: getRegionsURL(),
      },
    });
  };
}

export { loadRegions };
export default reducer;
